


























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import ActeurPastille from '@/components/MainSection/ActeurPastille.vue';
import PopupTrigger from '@/components/Popup/PopupTrigger.vue';
import { PopupList } from '@/constants/utils';

@Component({
	components: {
		ActeurPastille,
		PopupTrigger
	}
})
export default class CartePeriode extends Vue {
	@Prop({ required: true })
	acteurs!: string;

	@Prop({ required: true })
	nom!: string;

	@Prop({ required: true })
	subnom!: string;

	@Prop({ required: true })
	cultures!: Array<string>;

	@Prop({ required: true })
	qspt!: Array<string>;

	@Prop({ required: true })
	gabarit!: number;

	@Prop({ required: true })
	background!: string;

	@Prop({ required: true })
	backgroundy!: string;

	get imgUrl(): string | null {
		if (this.background) {
			return require('@/assets/img/' + this.background + '.jpg');
		} else {
			return '';
		}
	}

	private List(text: string): any {
		return PopupList(text);
	}
}
